import { useVersionControl } from "./use-version-control";

export const VersionControlModule = () => {
  useVersionControl();

  return null;
};
